import { Component } from '@angular/core';

@Component({
  selector: 'app-experiment-create-import-dataset',
  templateUrl: './experiment-create-import-dataset.component.html',
  styleUrl: './experiment-create-import-dataset.component.css'
})
export class ExperimentCreateImportDatasetComponent {

}
